import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../../public/locales/en/common.json";
import translationES from "../../public/locales/es/common.json";
import translationPT from "../../public/locales/pt/common.json";
import translationFR from "../../public/locales/fr/common.json";
import translationJA from "../../public/locales/ja/common.json";
import translationDE from "../../public/locales/de/common.json";
import partnersEN from "../../public/locales/en/partners.json";
import partnersES from "../../public/locales/es/partners.json";
import partnersPT from "../../public/locales/pt/partners.json";
import partnersFR from "../../public/locales/fr/partners.json";
import partnersJA from "../../public/locales/ja/partners.json";
import partnersDE from "../../public/locales/de/partners.json";
import blogEN from "../../public/locales/en/blog.json";
import blogES from "../../public/locales/es/blog.json";
import blogPT from "../../public/locales/pt/blog.json";
import blogFR from "../../public/locales/fr/blog.json";
import blogJA from "../../public/locales/ja/blog.json";
import blogDE from "../../public/locales/de/blog.json";
import routesEN from "../../public/locales/en/routes.json";
import routesES from "../../public/locales/es/routes.json";
import routesPT from "../../public/locales/pt/routes.json";
import routesFR from "../../public/locales/fr/routes.json";
import routesJA from "../../public/locales/ja/routes.json";
import routesDE from "../../public/locales/de/routes.json";
import industryHealthcareEN from "../../public/locales/en/industry-healthcare.json";
import industryHealthcareES from "../../public/locales/es/industry-healthcare.json";
import industryHealthcarePT from "../../public/locales/pt/industry-healthcare.json";
import industryHealthcareFR from "../../public/locales/fr/industry-healthcare.json";
import industryHealthcareJA from "../../public/locales/ja/industry-healthcare.json";
import industryHealthcareDE from "../../public/locales/de/industry-healthcare.json";
import industryPartnersEN from "../../public/locales/en/industry-partners.json";
import industryPartnersES from "../../public/locales/es/industry-partners.json";
import industryPartnersPT from "../../public/locales/pt/industry-partners.json";
import industryPartnersFR from "../../public/locales/fr/industry-partners.json";
import industryPartnersJA from "../../public/locales/ja/industry-partners.json";
import industryPartnersDE from "../../public/locales/de/industry-partners.json";
import collectionsEN from "../../public/locales/en/collections.json";
import collectionsES from "../../public/locales/es/collections.json";
import collectionsPT from "../../public/locales/pt/collections.json";
import collectionsFR from "../../public/locales/fr/collections.json";
import collectionsJA from "../../public/locales/ja/collections.json";
import collectionsDE from "../../public/locales/de/collections.json";
import insuranceEN from "../../public/locales/en/insurance.json";
import insuranceES from "../../public/locales/es/insurance.json";
import insurancePT from "../../public/locales/pt/insurance.json";
import insuranceFR from "../../public/locales/fr/insurance.json";
import insuranceJA from "../../public/locales/ja/insurance.json";
import insuranceDE from "../../public/locales/de/insurance.json";
import legalEN from "../../public/locales/en/legal.json";
import legalES from "../../public/locales/es/legal.json";
import legalPT from "../../public/locales/pt/legal.json";
import legalFR from "../../public/locales/fr/legal.json";
import legalJA from "../../public/locales/ja/legal.json";
import legalDE from "../../public/locales/de/legal.json";

const resources = {
  en: {
    translation: translationEN,
    partners: partnersEN,
    blog: blogEN,
    routes: routesEN,
    "industry-healthcare": industryHealthcareEN,
    "industry-partners": industryPartnersEN,
    collections: collectionsEN,
    insurance: insuranceEN,
    legal: legalEN,
  },
  es: {
    translation: translationES,
    partners: partnersES,
    blog: blogES,
    routes: routesES,
    "industry-healthcare": industryHealthcareES,
    "industry-partners": industryPartnersES,
    collections: collectionsES,
    insurance: insuranceES,
    legal: legalES,
  },
  pt: {
    translation: translationPT,
    partners: partnersPT,
    blog: blogPT,
    routes: routesPT,
    "industry-healthcare": industryHealthcarePT,
    "industry-partners": industryPartnersPT,
    collections: collectionsPT,
    insurance: insurancePT,
    legal: legalPT,
  },
  fr: {
    translation: translationFR,
    partners: partnersFR,
    blog: blogFR,
    routes: routesFR,
    "industry-healthcare": industryHealthcareFR,
    "industry-partners": industryPartnersFR,
    collections: collectionsFR,
    insurance: insuranceFR,
    legal: legalFR,
  },
  ja: {
    translation: translationJA,
    partners: partnersJA,
    blog: blogJA,
    routes: routesJA,
    "industry-healthcare": industryHealthcareJA,
    "industry-partners": industryPartnersJA,
    collections: collectionsJA,
    insurance: insuranceJA,
    legal: legalJA,
  },
  de: {
    translation: translationDE,
    partners: partnersDE,
    blog: blogDE,
    routes: routesDE,
    "industry-healthcare": industryHealthcareDE,
    "industry-partners": industryPartnersDE,
    collections: collectionsDE,
    insurance: insuranceDE,
    legal: legalDE,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",
    supportedLngs: ["en", "es", "pt", "fr", "ja", "de"],
    ns: ["translation", "partners", "blog", "routes", "industry-healthcare", "industry-partners", "collections", "insurance", "legal"],
    defaultNS: "translation",
    debug: false,
    keySeparator: ".",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
